import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { httpOptionsWithSkipErrorInterceptor } from '../common/functions-and-constant/interceptor';
import { AlertRule } from '../models/alert';
import { URLService } from './dynamic-url.service';

@Injectable({
  providedIn: 'root',
})
export class AlertRuleService {
  constructor(private readonly http: HttpClient, private readonly urlService: URLService) {}

  /** The institution's override per type where one exists, otherwise the global default. */
  getAlertRules(): Observable<AlertRule[]> {
    return this.http
      .get<{ alertRules: AlertRule[] }>(`${this.urlService.getDynamicUrl()}/alerts/rules`, {
        ...httpOptionsWithSkipErrorInterceptor,
      })
      .pipe(map((response) => response.alertRules));
  }

  /**
   * Upserts an institution override per rule. Each entry must be the complete
   * rule as returned by getAlertRules — the API writes what it is given, so a
   * partial one drops the fields it omits back to their schema defaults.
   */
  updateAlertRules(alertRules: AlertRule[]): Observable<AlertRule[]> {
    return this.http
      .put<{ alertRules: AlertRule[] }>(
        `${this.urlService.getDynamicUrl()}/alerts/rules`,
        { alertRules },
        { ...httpOptionsWithSkipErrorInterceptor },
      )
      .pipe(map((response) => response.alertRules));
  }
}
